<header class="px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">
    {{ isEditMode ? "Edit update note" : "New update note" }}
  </h1>
  <p class="text-sm text-greyscale-600">
    Plain text only. Line breaks are preserved. No Markdown or HTML.
  </p>
</header>

<main class="p-4">
  @if (isLoading) {
    <div class="flex h-64 items-center justify-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="submit()" class="max-w-3xl">
      <div class="mb-4 flex flex-wrap gap-4">
        <div class="flex flex-col gap-1">
          <label for="type" class="text-sm font-medium text-greyscale-700">
            Type *
          </label>
          <p-select
            inputId="type"
            formControlName="type"
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select a type"
          ></p-select>
          @if (form.controls.type.touched && form.controls.type.invalid) {
            <small class="text-red-600">A type is required.</small>
          }
        </div>

        <div class="flex flex-col gap-1">
          <label for="releasedAt" class="text-sm font-medium text-greyscale-700">
            Released at *
          </label>
          <p-datepicker
            inputId="releasedAt"
            formControlName="releasedAt"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
          ></p-datepicker>
          @if (
            form.controls.releasedAt.touched && form.controls.releasedAt.invalid
          ) {
            <small class="text-red-600">A release date is required.</small>
          }
        </div>
      </div>

      <div class="mb-4 flex flex-col gap-1">
        <label for="contentFR" class="text-sm font-medium text-greyscale-700">
          Content (FR) *
        </label>
        <textarea
          id="contentFR"
          pTextarea
          formControlName="contentFR"
          rows="10"
          class="w-full"
        ></textarea>
        @if (form.controls.contentFR.touched && form.controls.contentFR.invalid) {
          <small class="text-red-600">French content is required.</small>
        }
      </div>

      <div class="mb-4 flex flex-col gap-1">
        <label for="contentEN" class="text-sm font-medium text-greyscale-700">
          Content (EN) *
        </label>
        <textarea
          id="contentEN"
          pTextarea
          formControlName="contentEN"
          rows="10"
          class="w-full"
        ></textarea>
        @if (form.controls.contentEN.touched && form.controls.contentEN.invalid) {
          <small class="text-red-600">English content is required.</small>
        }
      </div>

      <div class="mb-6 flex flex-col gap-1">
        <label for="contentNL" class="text-sm font-medium text-greyscale-700">
          Content (NL) *
        </label>
        <textarea
          id="contentNL"
          pTextarea
          formControlName="contentNL"
          rows="10"
          class="w-full"
        ></textarea>
        @if (form.controls.contentNL.touched && form.controls.contentNL.invalid) {
          <small class="text-red-600">Dutch content is required.</small>
        }
      </div>

      <div class="flex items-center gap-2">
        <p-button
          type="submit"
          label="Save"
          icon="pi pi-check"
          [loading]="isSaving"
        />
        <p-button
          type="button"
          label="Cancel"
          severity="secondary"
          [text]="true"
          (onClick)="cancel()"
        />
      </div>
    </form>
  }
</main>
